import { Observable, ReplaySubject } from 'rxjs';

export abstract class ConfigBaseService {
  protected initSubject = new ReplaySubject<any>();

  init(environment: any) {
    Object.assign(this, environment);
    this.initSubject.next(null);
    this.initSubject.complete();
  }

  onInit(): Observable<any> {
    return this.initSubject;
  }
}
